module.exports = __webpack_public_path__ + "images/fa-cfa-footer-mobile.webp";